import { useMemo } from 'react';
import { Dirary } from '../../types/dirary';

export const useCheckDiaryList = (
  diaryList: Dirary[],
  fetchDiaryList: Dirary[]
) => {
  //追加/更新/削除の差分を「同期的に」算出する。
  //旧実装は useEffect + useState の3本立てで、diaryList が変わってから
  //各リストが更新されるまで1レンダの遅延があった。そのため全件削除直後の
  //1レンダだけ deleteDiaryList が空のまま送信可否が判定され、「更新ボタンが
  //一瞬押せない」過渡(症状①)が発生していた。useMemo で同期化して遅延を解消し、
  //setState 連発によるレンダも削減する。戻り値の形と差分ロジックは従来と同一。
  return useMemo(() => {
    const deleteList: Dirary[] = [];
    const updateList: Dirary[] = [];
    const addList: Dirary[] = [];

    // FetchのIDセットを作成
    const fetchDiaryIdSet = new Set(fetchDiaryList.map((diary) => diary.id));
    const diaryIdSet = new Set(diaryList.map((diary) => diary.id));

    // 削除リストの作成: fetch にあって diary にない
    fetchDiaryList.forEach((fetchDiary) => {
      if (!diaryIdSet.has(fetchDiary.id)) {
        deleteList.push(fetchDiary);
      }
    });

    // 更新リストの作成: fetch と diary の両方に存在
    fetchDiaryList.forEach((fetchDiary) => {
      const correspondingDiary = diaryList.find(
        (diary) => diary.id === fetchDiary.id
      );
      if (
        correspondingDiary //&&
        //JSON.stringify(fetchDiary) !== JSON.stringify(correspondingDiary)
      ) {
        updateList.push(correspondingDiary);
      }
    });

    // 追加リストの作成: fetch になく、id<=0(新規発行ID)
    diaryList.forEach((diary) => {
      if (!fetchDiaryIdSet.has(diary.id) && diary.id <= 0) {
        addList.push(diary);
      }
    });

    return {
      deleteDiaryList: deleteList,
      updateDiaryList: updateList,
      addDiaryList: addList,
    };
  }, [diaryList, fetchDiaryList]);
};
